// extracted by mini-css-extract-plugin
var _1 = "UserEditAddressFormModal-modulecontent__b18UG";
var _2 = "UserEditAddressFormModal-modulecontentWrapper__hEfUk Content-modulecontentWrapper__p1AMw";
export { _1 as "content", _2 as "contentWrapper" }
